import { jsxs as N, jsx as s } from "react/jsx-runtime";
import { MinusIcon as $ } from "../../icons/MinusIcon.js";
import { PlusIcon as j } from "../../icons/PlusIcon.js";
import f from "clsx";
import { TrashIcon as D } from "../../icons/TrashIcon.js";
import '../../_assets/QuantityEditor.BTkN4iQ5.css';const P = "_root_1bpcf_44", W = "_btn_1bpcf_55", w = "_disabled_1bpcf_76", x = "_remove_1bpcf_80", E = "_count_1bpcf_84", e = {
  root: P,
  btn: W,
  disabled: w,
  remove: x,
  count: E
}, A = ({
  quantity: t,
  max: c,
  min: a = 1,
  mode: b = "subscription",
  useTrashIcon: m,
  className: p,
  disabled: i,
  onChange: o,
  onRemove: d,
  onIncrementDisabled: n,
  dataTestId: r = "quantity-editor"
}) => {
  const _ = () => {
    t > a ? o && o(t - 1) : d ? d() : o && o(0);
  }, u = () => {
    o && o(t + 1);
  }, h = () => {
    if (i) {
      n && n();
      return;
    }
    if (c !== void 0 && t >= c) {
      n && n();
      return;
    }
    u();
  }, v = i || t <= a && !d, k = i || c !== void 0 && t >= c, l = m && b === "order" && t === 1;
  return /* @__PURE__ */ N("div", { className: f(e.root, p), "data-testid": r, children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        disabled: v,
        onClick: _,
        className: f(e.btn, l ? e.remove : e.minus),
        "aria-label": l ? "Remove item" : "Decrease quantity",
        "data-testid": l ? `${r}-remove` : `${r}-decrease`,
        children: l ? /* @__PURE__ */ s(D, {}) : /* @__PURE__ */ s($, { strokeWidth: 1 })
      }
    ),
    /* @__PURE__ */ s("span", { className: e.count, "data-testid": `${r}-value`, children: t }),
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        disabled: i,
        onClick: h,
        className: f(e.btn, k && e.disabled),
        "aria-label": "Increase quantity",
        "data-testid": `${r}-increase`,
        children: /* @__PURE__ */ s(j, { hasPadding: !1, strokeWidth: 1 })
      }
    )
  ] });
};
export {
  A as QuantityEditor
};
